export default "__VITE_ASSET__D4tb1dm1__"